import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

const Checkbox = ({ name, disabled, checked, id, ...rest }) => {
  return (
    <label className="checkbox">
      <input
        type="checkbox"
        name={name}
        id={id}
        disabled={disabled}
        checked={checked}
        {...rest}
      />
      <span></span>
    </label>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool
}

export default Checkbox;
